const calorieCounterHelp = [
    {
        id: 1,
        text: "در این صفحه شما می توانید کالری مورد نظر خود را با استفاده از راهنماییهای مربی تغذیه تعیین و بررسی کنید"
    },
    {
        id: 2,
        text: "در صورت خرید پکیج تغذیه، برنامه غذایی شما روزانه توسط مربی بررسی و اطلاعات مورد نیاز به صورت ایمیل برای شما ارسال خواهد شد"
    }
]

export default calorieCounterHelp